module.exports = __webpack_public_path__ + "img/lqclzt3.4c7f0b10.svg";